import React from "react";
import Reports from "./Pages/reports";
import WorkTimeTrackingOverview from "./Pages/overview";
import WorkTimeTrackingCalender from "./Pages/worktimetrackingcalender";
import TimeSheet from "./Pages/timeSheet";
import Planer from "./Pages/planer";
import {CryptDecrypt} from "../../@WUM/core/Elements/crypt/Crypt";
import SettingsOverview from "./Pages/settings";
import EmployeeOverview from "./Pages/employeeOverview";
import {LanguageSwitcherValue} from "../ticketsystem/modules/components/LanguageSwitcher";
import CheckPermissions from "../../@WUM/core/Function/Permissions/CheckPermissions";
import Userplaner from "./Pages/userPlaner";

const permissions = [
    'Auto_Breeak_Out_Settings_User',
    'Auto_Clock_Settings_User',
    'Dashboard',
    'Employee',
    'General_Settings_User',
    'Planer',
    'Settings',
    'Time_Entries',
    'Time_Sheet',
];

export const WorkTimeTrackingConfig = (value:any) => {
    if(localStorage.getItem('userRights') !== null && localStorage.getItem('userRights') !== undefined && JSON.parse(CryptDecrypt(localStorage.getItem('userRights') as string) as string).worktimetracking === 0) {
        return []
    } else {

        const allowed = CheckPermissions('Arbeitszeiterfassung', permissions);

        if (!allowed) {
            return []
        }

        const planerPermission = CheckPermissions('Arbeitszeiterfassung', ['Planer']);


        return [
            {
                path: '/worktime/tracking/overview/:page',
                elements: <WorkTimeTrackingOverview value={value}/>,
                roles: ['superadmin', 'admin', 'worktime']
            },
            {
                path: '/calender/worktime/tracking/software/:page',
                elements: <WorkTimeTrackingCalender value={value}/>,
                roles: ['superadmin', 'admin', 'worktime']
            },
            {
                path: '/time/sheet/work/time/:page',
                elements: <TimeSheet value={value}/>,
                roles: ['superadmin', 'admin', 'worktime']
            },
            {
                path: planerPermission
                    ? '/planer/work/time/:page'
                    : '/user-planer/work/time/:page',
                elements: planerPermission
                    ? <Planer value={value}/>
                    : <Userplaner value={value}/>,
                roles: ['superadmin', 'admin', 'worktime']
            },
            {
                path: '/software/report/support/:page',
                elements: <Reports value={value}/>,
                roles: ['superadmin', 'admin', 'worktime']
            },
            {
                path: '/settings/worktime',
                elements: <SettingsOverview value={value}/>,
                roles: ['superadmin', 'admin', 'worktime']
            },
            {
                path: '/employee-overview/:page',
                elements: <EmployeeOverview value={"value"}/>,
                roles: ['superadmin', 'admin', 'worktime']
            }
        ]
    }
}

export const WorkTimeTrackingMenuConfig = (value:any) => {

    const allowed = CheckPermissions('Arbeitszeiterfassung', permissions);

    const planerPermission = CheckPermissions('Arbeitszeiterfassung', ['Planer']);

    if(localStorage.getItem('userRights') !== null && localStorage.getItem('userRights') !== undefined && JSON.parse(CryptDecrypt(localStorage.getItem('userRights') as string) as string).worktimetracking === 0) {
        return []
    } else {
        return [
            {
                header: 'Arbeitszeiterfassung',
                icon: 'hourglass_empty',
                roles: ['superadmin', 'worktime'],
                show: allowed,
                menuitem: [
                    {
                        name: LanguageSwitcherValue('common.dashbaord'),
                        route: '/worktime/tracking/overview/1',
                        icon: 'dashboard',
                        roles: ['superadmin', 'admin', 'worktime']
                    },
                    {
                        name: LanguageSwitcherValue('Zeiteinträge'),
                        route: '/calender/worktime/tracking/software/1',
                        icon: 'alarm_on',
                        roles: ['superadmin', 'admin', 'worktime']
                    },
                    {
                        name: 'Stundenzettel',
                        route: '/time/sheet/work/time/1',
                        icon: 'alarm',
                        roles: ['superadmin', 'admin', 'worktime']
                    },
                    {
                        name: planerPermission ? 'Planer' : 'Dienstplan',
                        route: planerPermission
                            ? '/planer/work/time/1'
                            : '/user-planer/work/time/1',
                        icon: 'calendar_today',
                        roles: ['superadmin', 'admin', 'worktime']
                    },
                    {
                        name: 'Einstellungen',
                        route: '/settings/worktime',
                        icon: 'settings',
                        roles: ['superadmin', 'admin', 'worktime']
                    },
                    {
                        name: 'Mitarbeiter',
                        route: '/employee-overview/1',
                        icon: 'assignment_ind',
                        roles: ['superadmin', 'admin', 'worktime']
                    },

                    /*
            {
                name: 'Berichte',
                route: '/software/report/support/1',
                icon: 'query_stats',
                roles: ['superadmin', 'admin', 'worktime']
            }*/
                ]
            }
        ]
    }
}

export const WorkTimeTracking = () => [

    {
        title: 'Dashboard',
        href: '/worktime/tracking/overview/1',
        undertitle: 'Arbeitszeiterfassung',
        icon: 'dashboard',
        text: 'Arbeitszeiterfassung',
        roles: ['superadmin', 'admin', 'worktime']
    },
    {
        title: 'Time Entries',
        href: '/calender/worktime/tracking/software/1',
        undertitle: 'Arbeitszeiterfassung',
        icon: 'alarm_on',
        text: 'Arbeitszeiterfassung',
        roles: ['superadmin', 'admin', 'worktime']
    },
    {
        title: 'Time Sheets',
        href: '/time/sheet/work/time/1',
        undertitle: 'Arbeitszeiterfassung',
        icon: 'calendar_today',
        text: 'Arbeitszeiterfassung',
        roles: ['superadmin', 'admin', 'worktime']
    },
    {
        title: 'Planer',
        href: '/planer/work/time/1',
        undertitle: 'Arbeitszeiterfassung',
        icon: 'alarm',
        text: 'Arbeitszeiterfassung',
        roles: ['superadmin', 'admin', 'worktime']
    },
    {
        title: 'Dienstplan',
        href: '/planer-user/work/time/1',
        undertitle: 'Arbeitszeiterfassung',
        icon: 'alarm',
        text: 'Arbeitszeiterfassung',
        roles: ['superadmin', 'admin', 'worktime']
    },
    {
        title: 'Settings',
        href: '/settings/worktime',
        undertitle: 'Arbeitszeiterfassung',
        icon: 'alarm',
        text: 'Arbeitszeiterfassung',
        roles: ['superadmin', 'admin', 'worktime']
    },
    {
        title: 'Mitarbeiter',
        href: '/employee-overview',
        undertitle: 'Arbeitszeiterfassung',
        icon: 'assignment_ind',
        text: 'Arbeitszeiterfassung',
        roles: ['superadmin', 'admin', 'worktime'],
    },
]
